// extracted by mini-css-extract-plugin
export var contentWrapper = "shared-module--contentWrapper--8ce89";
export var contentWrapperDesktop = "shared-module--contentWrapperDesktop--bc591";
export var contentWrapperMobile = "shared-module--contentWrapperMobile--77b9d";